import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from "@angular/material/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { getTablePaginatorIntl } from "../assets/typescript/table.customization";
import { environment } from "../environments/environment";
import { NewFeedEffects } from "./store/newsfeed/newsfeed.effects";
import { RecentActivityEffects } from "./store/notification/notification.effects";
import { TrendingTagsEffects } from "./store/trending-tags/trending.tags.effects";
import { UserRewardsEffects } from "./store/user-rewards/user.rewards.effects";
import { StatsEffects } from "./store/user-stats/user.stats.effects";
import { ROUTES } from "./recognition.app.routes";

/*Providers */
import { CommonValidator } from "./providers/Directive/common.validator.directive";
import { AuthInterceptor } from "./providers/interceptor/auth.interceptor";
import { ErrorInterceptor } from "./providers/interceptor/error.interceptor";
import { ErrorHandleService } from "./providers/interceptor/handler.error.service";
import { RequestHandleService } from "./providers/interceptor/handler.request.service";
import { ProvidersModule } from "./providers/providers.module";

/*Component*/
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { StoreModule } from "@ngrx/store";
import { WishlistLoaderModule } from "../../../wishlist-loader/src/public-api";
import { SnackBarComponent } from "./providers/snackbar/snackbar/snackbar.component";
import { ToastComponent } from "./providers/toast/toast/toast.component";
import { RecognitionAppComponent } from "./recognition.app.component";
import { metaReducers, reducers } from "./store/meta-reducer";

/*Store*/
import { EffectsModule } from "@ngrx/effects";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { RsaEncryptionModule } from "projects/rsa-encryption";
import { CoworkerCacheServiceModule } from "../../../coworker-service";
import { RecognitionRenderFilterEffects } from "./store/recognition-render-filter/recognition.render.filter.effects";
import { RecognitionRenderNormalEffects } from "./store/recognition-render-normal/recognition.render.normal.effects";
import { PopularSearchEffects } from "./store/filtering/popular.search.effects";
import { TagSearchEffects } from "./store/filtering/tag.search.effects";
import { ThankYouNotesEffects } from "./store/thankyou-notes/thankyou.notes.effects";
import { UsageInsightsffects } from "./store/usage-insights/usage.insights.effects";
import { hrSystemDisconnectConfirmationModule } from "./common/hrSystem.disconnect.confirm.dialog";
import { BusinessGoalEffects } from "./store/business-goal/business.goal.effects";
import { RewardTagEffects } from "./store/reward-tag/reward.tag.effects";
import { RecognitionPreloadStrategyService } from "./recognition.preload.service";
import { StoreService } from "./store/store.service";
import { CompanyValueEffects } from "./store/company-value/company.value.effects";

@NgModule({
  declarations: [RecognitionAppComponent, ToastComponent, SnackBarComponent, CommonValidator],
  bootstrap: [RecognitionAppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    MatIconModule,
    BrowserAnimationsModule,
    WishlistLoaderModule,
    MatSnackBarModule,
    hrSystemDisconnectConfirmationModule,
    RsaEncryptionModule.forRoot(environment.rsaEncryptKey),
    RouterModule.forRoot(ROUTES, {
      scrollPositionRestoration: "enabled",
      onSameUrlNavigation: "reload",
      preloadingStrategy: RecognitionPreloadStrategyService,
    }),
    CoworkerCacheServiceModule.forRoot({ key: environment.cryptoEncryptionKey }),
    ProvidersModule.forRoot(),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
        strictActionSerializability: false,
        strictStateSerializability: false,
      },
    }),
    !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 25, connectInZone: true }) : [],
    EffectsModule.forRoot([
      StatsEffects,
      RecentActivityEffects,
      NewFeedEffects,
      UserRewardsEffects,
      ThankYouNotesEffects,
      StatsEffects,
      CompanyValueEffects,
      BusinessGoalEffects,
      RewardTagEffects,
      UsageInsightsffects,
      TrendingTagsEffects,
      PopularSearchEffects,
      TagSearchEffects,
      RecognitionRenderNormalEffects,
      RecognitionRenderFilterEffects,
    ]),
  ],
  providers: [
    StoreService,
    RequestHandleService,
    ErrorHandleService,
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MatPaginatorIntl, useValue: getTablePaginatorIntl() },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class RecognitionAppModule {}
